import tw from 'twin.macro';

// h-10 pins every text/date/number field to the same 40px box as <Select>, the
// react-select controls and <Button>; without it a filter row mixes 42px inputs
// with 36px selects and looks ragged even when the boxes are aligned.
const Input = tw.input`w-full h-10 bg-white rounded-md py-2 px-3 text-gray-500 shadow-md focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-500`;

export default Input;
